@if (isDropDown()) {
  <mat-form-field
    color="primary"
    [ngStyle]="{ 'font-size': fontSize }"
    [ngClass]="{ 'form-density-3 form-field-condensed': isInToolbar }"
    appearance="outline"
  >
    <mat-label>{{ 'COMMON.LABEL.ORDER_BY' | translate }}</mat-label>
    <mat-select
      placeholder="{{ 'COMMON.LABEL.ORDER_BY' | translate }}"
      (selectionChange)="onSelectionChange($event)"
      [formControl]="formControl"
      subscriptSizing="dynamic"
    >
      @for (option of options; track option) {
        <mat-option [value]="option.value">
          {{ option.label | translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (!isDropDown()) {
  <button mat-button [color]="color" (click)="sort(option)">
    {{ option.label | translate }}
    @if (option.value.direction === EBitfApiSortDirection.ASC) {
      <mat-icon>arrow_upward</mat-icon>
    }
    @if (option.value.direction === EBitfApiSortDirection.DESC) {
      <mat-icon>arrow_downward</mat-icon>
    }
  </button>
}
